// ═══════════════════════════════════════════════
// Audio feedback — contexte unique partagé
// Évite la fuite AudioContext (max ~6 sur mobile)
// ═══════════════════════════════════════════════

let _ctx = null;

function getCtx() {
  if (!_ctx) {
    try { _ctx = new (window.AudioContext || window.webkitAudioContext)(); }
    catch { return null; }
  }
  if (_ctx.state === 'suspended') _ctx.resume().catch(() => {});
  return _ctx;
}

export function beepSuccess() {
  const ctx = getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain); gain.connect(ctx.destination);
  osc.frequency.value = 880;
  gain.gain.value = 0.3;
  osc.start(); osc.stop(ctx.currentTime + 0.15);
}

export function beepError() {
  const ctx = getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain); gain.connect(ctx.destination);
  osc.frequency.value = 330;
  gain.gain.value = 0.3;
  osc.start(); osc.stop(ctx.currentTime + 0.3);
}

export function playBeep(type) {
  if (type === 'success') beepSuccess();
  else beepError();
}
